import { HTTP } from "../../http-common";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "../../models/httpError";
import { getField, updateField } from "vuex-map-fields";

const state = {
  rows: [],
  message: new httpError(),
};

const getters = {
  rows: (state) => {
    return state.rows;
  },
  message: (state) => {
    state.message;
  },
  getField,
};

const actions = {
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  },

  getFieldOptions({ commit, dispatch }, component = "all") {
    return new Promise((resolve, reject) => {
      HTTP.get("layout/GetLayoutFields/" + component)
        .then((res) => {
          if (res.status == 200) {
            commit("setFieldOptions", res.data);
          } else commit("reset");
          dispatch(
            "setMessage",
            new httpError({ message: "Retreived OK", httpStatus: 200 })
          );
          resolve(res.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error getting Interested:" + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateFieldOptions({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post("layout/UpdateFieldCondition", data)
        .then((res) => {
          if (res.status == 200) {
            dispatch("getFieldOptions");
          } else commit("reset");
          dispatch(
            "setMessage",
            new httpError({ message: "Update OK", httpStatus: 200 })
          );
          resolve(res.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error getting Interested:" + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  removeFieldOptions({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      HTTP.delete("layout/DeleteFieldCondition/"+id)
        .then((res) => {
          if (res.status == 200) {
            dispatch("getFieldOptions");
          } else commit("reset");
          dispatch(
            "setMessage",
            new httpError({ message: "Update OK", httpStatus: 200 })
          );
          resolve(res.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error getting Interested:" + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
};

const mutations = {
  setProgress(state, message) {
    state.message = message;
  },
  setFieldOptions(state, data) {
    state.rows = data;
  },
  reset(state) {
    state.rows = [];
    state.message = new httpError();
  },
  updateField,
};

const modules = {};
export const { mapFields: mapFieldOptionsFields } = createHelpers({
  getterType: `fieldOptions/getField`,
  mutationType: `fieldOptions/updateField`,
});

export const {
  mapMultiRowFields: mapFieldOptionsMultiRowFields,
} = createHelpers({
  getterType: "fieldOptions/getField",
  mutationType: "fieldOptions/updateField",
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
};
